export default __webpack_public_path__ + "static/all_weed_farm_locations-9ec933bba290e484513661978c00d209.png";